import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const BlacklistAreaAddEditRBAC = {
  pageID: '45767516b833275d7f997d335722e7d1',
  elementID: {
    ViewPage: 'aa0600962b8b51efa82c8760454ca3bf',
    AddLocation: '8f56db0dda5bd1d84e9ed06b068d95b7',
    Save: '40c437e6508b51ef93d2b8378a8065ce',
  },
} as const

export const useBlacklistAreaAddEditRBACPage = createUseRBAC(BlacklistAreaAddEditRBAC.elementID)

export type UseBlacklistAreaAddEditRBACPageType = ReturnType<typeof useBlacklistAreaAddEditRBACPage>
